import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { indexOf29nspdgx2e3ap as indexOf } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import {
  add2suhfggl4zvkk as add,
  fromInt2ii0rejb1w62w as fromInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { flushIfNeededij7q93lpr53w as flushIfNeeded } from './ByteWriteChannel.mjs';
import { writeBytequnf40dx25fy as writeByte } from './ByteWriteChannelOperations.mjs';
import { get_ONEazvfdh9ju3d4 as get_ONE } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/boxedLong/boxedLong.mjs';
import { IOException1wyutdmfe71nu as IOException } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import { decodeToString2ede220pr5xir as decodeToString } from '../../../../../kotlinx-io-kotlinx-io-bytestring/kotlinx/io/bytestring/ByteString.mjs';
import { replace3le3ie7l9k8aq as replace } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function buildPartialMatchTable($this) {
  var table = new Int32Array($this.r4n_1.q2());
  var j = 0;
  var inductionVariable = 1;
  var last = $this.r4n_1.q2();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      while (j > 0 && !($this.r4n_1.r2(i) === $this.r4n_1.r2(j))) {
        j = table[j - 1 | 0];
      }
      if ($this.r4n_1.r2(i) === $this.r4n_1.r2(j)) {
        j = j + 1 | 0;
      }
      table[i] = j;
    }
     while (inductionVariable < last);
  return table;
}
function *advanceToNextPotentialMatch($this, $completion) {
  while (!$this.u4n_1.s3y() || (yield* $this.q4n_1.k4n(VOID, $completion))) {
    var nextMatch = indexOf($this.u4n_1, $this.r4n_1.r2(0));
    if (nextMatch === -1n) {
      var tmp = $this.u4n_1;
      checkBounds($this, (tmp instanceof Buffer() ? tmp : THROW_CCE()).q2());
      $this.x4n_1 = add($this.x4n_1, $this.u4n_1.k4j($this.s4n_1.q4m()));
      yield* flushIfNeeded($this.s4n_1, $completion);
    } else {
      checkBounds($this, nextMatch);
      var tmp_0 = $this;
      var tmp_1 = $this.x4n_1;
      var tmp_2 = $this.s4n_1.q4m();
      tmp_0.x4n_1 = add(tmp_1, $this.u4n_1.h4j(tmp_2 instanceof Buffer() ? tmp_2 : THROW_CCE(), nextMatch));
      yield* flushIfNeeded($this.s4n_1, $completion);
      return Unit_instance;
    }
  }
  return Unit_instance;
}
function *checkFullMatch($this, $completion) {
  while (!$this.u4n_1.s3y() || (yield* $this.q4n_1.k4n(VOID, $completion))) {
    var byte = $this.u4n_1.b3z();
    if ($this.y4n_1 > 0 && !(byte === $this.r4n_1.r2($this.y4n_1))) {
      var oldMatchIndex = $this.y4n_1;
      while ($this.y4n_1 > 0 && !(byte === $this.r4n_1.r2($this.y4n_1))) {
        $this.y4n_1 = $this.v4n_1[$this.y4n_1 - 1 | 0];
      }
      var retained = fromInt(oldMatchIndex - $this.y4n_1 | 0);
      checkBounds($this, retained);
      var tmp = $this;
      var tmp_0 = $this.x4n_1;
      var tmp_1 = $this.s4n_1.q4m();
      tmp.x4n_1 = add(tmp_0, $this.w4n_1.h4j(tmp_1 instanceof Buffer() ? tmp_1 : THROW_CCE(), retained));
      if ($this.y4n_1 === 0 && !(byte === $this.r4n_1.r2($this.y4n_1))) {
        yield* writeByte($this.s4n_1, byte, $completion);
        var _unary__edvuaz = $this.x4n_1;
        $this.x4n_1 = add(_unary__edvuaz, get_ONE());
        return false;
      }
    }
    $this.y4n_1 = $this.y4n_1 + 1 | 0;
    if ($this.y4n_1 === $this.r4n_1.q2()) {
      return true;
    }
    $this.w4n_1.y4j(byte);
  }
  return false;
}
function checkBounds($this, extra) {
  if (add($this.x4n_1, extra) > $this.t4n_1) {
    throw IOException().i4l('Limit of ' + $this.t4n_1.toString() + ' bytes exceeded ' + ('while searching for "' + toSingleLineString($this, $this.r4n_1) + '"'));
  }
}
function toSingleLineString($this, $receiver) {
  return replace(decodeToString($receiver), '\n', '\\n');
}
var ByteChannelScannerClass;
function ByteChannelScanner() {
  if (ByteChannelScannerClass === VOID) {
    class $ {
      constructor(channel, matchString, writeChannel, limit) {
        limit = limit === VOID ? 9223372036854775807n : limit;
        this.q4n_1 = channel;
        this.r4n_1 = matchString;
        this.s4n_1 = writeChannel;
        this.t4n_1 = limit;
        // Inline function 'kotlin.require' call
        if (!(this.r4n_1.q2() > 0)) {
          var message = 'Empty match string not permitted for scanning';
          throw IllegalArgumentException().o2(toString(message));
        }
        this.u4n_1 = this.q4n_1.k4m();
        this.v4n_1 = buildPartialMatchTable(this);
        this.w4n_1 = new (Buffer())();
        this.x4n_1 = 0n;
        this.y4n_1 = 0;
      }
      *z4n(ignoreMissing, $completion) {
        this.x4n_1 = 0n;
        while (!this.u4n_1.s3y() || (yield* this.q4n_1.k4n(VOID, $completion))) {
          yield* /*#__NOINLINE__*/advanceToNextPotentialMatch(this, $completion);
          if (yield* /*#__NOINLINE__*/checkFullMatch(this, $completion)) {
            return this.x4n_1;
          }
        }
        if (!ignoreMissing) {
          throw IOException().i4l('Expected "' + toSingleLineString(this, this.r4n_1) + '" but encountered end of input');
        }
        this.x4n_1 = add(this.x4n_1, this.w4n_1.k4j(this.s4n_1.q4m()));
        yield* this.s4n_1.l4n($completion);
        return this.x4n_1;
      }
    }
    initMetadataForClass($, 'ByteChannelScanner', VOID, VOID, VOID, [1, 0]);
    ByteChannelScannerClass = $;
  }
  return ByteChannelScannerClass;
}
//region block: exports
export {
  ByteChannelScanner as ByteChannelScanner1h148q1m3y1ey,
};
//endregion

//# sourceMappingURL=ByteChannelScanner.mjs.map
